module.exports = __webpack_public_path__ + "static/media/sf-test-5.5dc81483.mp3";